// index.js
import Vue from 'vue'
import Vuex from 'vuex'
import stateStore from '../store/state'
import App from './App.vue'
Vue.config.productionTip = false

Vue.use(Vuex)

const store = new Vuex.Store(stateStore)

new Vue({
    el: '#event-filters',
    components: {
        App
    },
    store: store
})
